export const getMicrosoftGraphEventIntegration = (followup) => {
  const integrations = followup?.integrations;
  if (!Array.isArray(integrations)) return null;

  const integration = integrations.find(
    (i) => i?.type === "microsoft_graph_event"
  );
  const eventId = integration?.payload?.eventId;
  const userId = integration?.payload?.userId;

  if (!eventId || typeof eventId !== "string") return null;

  return {
    eventId,
    userId: typeof userId === "string" && userId ? userId : null,
  };
};
